module.exports = __webpack_public_path__ + "static/img/weibaoming.bda4dc60.png";